package com.fantasytenis.shared.domain.auth.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.data.auth.repository.AuthRepository
import com.fantasytenis.shared.domain.auth.entity.UserEntity

/**
 * Get Current User Use Case.
 *
 * Fetches the currently authenticated user's profile.
 */
class GetCurrentUserUseCase(
    private val authRepository: AuthRepository
) {
    /**
     * Execute get current user.
     *
     * @return Result containing UserEntity on success
     */
    suspend operator fun invoke(): Result<UserEntity> {
        return authRepository.getCurrentUser()
            .onSuccess { user ->
                // Update global state
                SharedData.currentUser.value = user
            }
    }
}
